// extracted by mini-css-extract-plugin
module.exports = {"root":"SearchMap_root__1r5mK","mapRoot":"SearchMap_mapRoot__3gElK"};